<template>
  <div class="ReportPanel panel">
    <div class="panel-header">
      <div class="summary">
        <h1 class="light">
          {{ title }}
        </h1>

        <ReportStatus :status="status" />
      </div>
    </div>

    <slot>Your report comes here</slot>
  </div>
</template>

<script>
import ReportStatus from "@/components/ReportStatus";
export default {
  components: { ReportStatus },
  data: function () {
    return {};
  },

  props: {
    title: {
      type: String,
      default: "Default report title",
    },
    status: {
      type: String,
      default: "DRAFT",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";

.ReportPanel {
  flex: 1;

  @include phone {
    .hide-mobile {
      display: none;
    }
  }
  .summary {
    display: flex;
    flex: 1;
    @include phone {
      flex-direction: column;
    }
  }

  .panel-header {
    display: flex;
    h1 {
      margin: 0;

      @include phone {
        font-size: 1.428em;
      }
    }
  }
}
</style>
